export const defaultSettings = {
    lastSeen: false,
    readReceipt: false,
    joiningGroups: false,
    privateMessages: false,
    darkMode: false,
    allowNotifications: false,
    keepNotifications: false,
};

export default {
    defaultSettings
} as const;
